import * as tslib_1 from "tslib";
import * as moment from 'moment';
import { Database, Meal, MealItem } from './database';
import * as i0 from "@angular/core";
export { ActivityLevel, Day, Meal, MealItem, MealName } from './database';
var Data = /** @class */ (function (_super) {
    tslib_1.__extends(Data, _super);
    function Data() {
        var _this = _super.call(this, 1) || this;
        window.db = _this;
        if (!moment) {
            throw new Error('invalid setup, moment isn\'t getting loaded');
        }
        return _this;
    }
    /**
     * Get the list of table names required for seeding
     */
    Data.prototype.seedTableNames = function () {
        return [
            'foods',
            'weights',
        ];
    };
    Data.prototype.getMeal = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dbMeal, e_1, items, mealItems;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.meals.get(id)];
                    case 1:
                        dbMeal = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error('error getting dbMeal', id, e_1);
                        return [3 /*break*/, 3];
                    case 3:
                        if (!dbMeal) {
                            throw new Error('No meal found');
                        }
                        return [4 /*yield*/, this.mealItems.where('mealId').equals(dbMeal.id).toArray()];
                    case 4:
                        items = _a.sent();
                        mealItems = items.map(function (i) { return new MealItem(i.name, i.calories, i.carbs, i.protein, i.fat, i.mealId, i.id); });
                        return [2 /*return*/, new Meal(dbMeal.name, dbMeal.time, mealItems, dbMeal.dayId, dbMeal.id)];
                }
            });
        });
    };
    Data.prototype.updateMeal = function (id, date, name, items, deleted) {
        if (deleted === void 0) { deleted = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dayDate, day, e_2, dayId, e_3, time, iMeal, itemIds, toBeDeleted;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dayDate = date.clone();
                        dayDate.startOf('day');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.days.where('date').equals(+dayDate).first()];
                    case 2:
                        day = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.error('Failed to get day from date', dayDate.toLocaleString());
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!day) return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.days.put({
                                date: +dayDate,
                                deleted: false,
                            })];
                    case 6:
                        dayId = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_3 = _a.sent();
                        return [2 /*return*/, console.error('Failed to insert non-existent day', dayDate.toLocaleString())];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        dayId = day.id;
                        _a.label = 10;
                    case 10:
                        time = {
                            hours: date.hours(),
                            minutes: date.minutes(),
                        };
                        iMeal = {
                            id: id,
                            dayId: dayId,
                            name: name,
                            time: time,
                            deleted: deleted,
                        };
                        return [4 /*yield*/, this.meals.put(iMeal)];
                    case 11:
                        _a.sent();
                        itemIds = items.map(function (i) { return i.id; }).filter(function (i) { return i; });
                        return [4 /*yield*/, this.mealItems.where('mealId').equals(id).and(function (item) { return itemIds.indexOf(item.id) < 0; }).primaryKeys()];
                    case 12:
                        toBeDeleted = _a.sent();
                        return [4 /*yield*/, this.mealItems.bulkDelete(toBeDeleted)];
                    case 13:
                        _a.sent();
                        return [4 /*yield*/, this.mealItems.bulkPut(items.map(function (item) {
                                item.mealId = id;
                                return item;
                            }))];
                    case 14:
                        _a.sent();
                        this.renderableChanges.emit();
                        this.syncableChanges.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    Data.prototype.addMeal = function (date, name, contents) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dayDate, day, e_4, dayId, e_5, time, mealId, iMeal, e_6, _i, contents_1, item, e_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dayDate = date.clone().startOf('day');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.days.where('date').equals(+dayDate).first()];
                    case 2:
                        day = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        console.error('Failed to get day from date', dayDate.toLocaleString());
                        return [3 /*break*/, 4];
                    case 4:
                        if (!!day) return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.days.put({
                                date: +dayDate,
                                deleted: false,
                            })];
                    case 6:
                        dayId = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_5 = _a.sent();
                        return [2 /*return*/, console.error('Failed to insert non-existent day', dayDate.toLocaleString())];
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        dayId = day.id;
                        _a.label = 10;
                    case 10:
                        time = {
                            hours: date.hours(),
                            minutes: date.minutes(),
                        };
                        iMeal = {
                            dayId: dayId,
                            name: name,
                            time: time,
                            deleted: false,
                        };
                        _a.label = 11;
                    case 11:
                        _a.trys.push([11, 13, , 14]);
                        return [4 /*yield*/, this.meals.put(iMeal)];
                    case 12:
                        mealId = _a.sent();
                        return [3 /*break*/, 14];
                    case 13:
                        e_6 = _a.sent();
                        return [2 /*return*/, console.error('Failed to insert new meal', iMeal)];
                    case 14:
                        _i = 0, contents_1 = contents;
                        _a.label = 15;
                    case 15:
                        if (!(_i < contents_1.length)) return [3 /*break*/, 20];
                        item = contents_1[_i];
                        item.mealId = mealId;
                        _a.label = 16;
                    case 16:
                        _a.trys.push([16, 18, , 19]);
                        return [4 /*yield*/, this.mealItems.put(item)];
                    case 17:
                        _a.sent();
                        return [3 /*break*/, 19];
                    case 18:
                        e_7 = _a.sent();
                        return [2 /*return*/, console.error('failed to insert mealItem', item)];
                    case 19:
                        _i++;
                        return [3 /*break*/, 15];
                    case 20:
                        this.renderableChanges.emit();
                        this.syncableChanges.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    Data.prototype.getRecentWeightSets = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var days, i, batch, _i, batch_1, set, ret, dates, _a, dates_1, dayKey, day, _b, _c, weightKey;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        days = {};
                        i = 0;
                        _d.label = 1;
                    case 1:
                        if (!true) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.weightSets
                                .orderBy('when')
                                .reverse()
                                .limit(50)
                                .offset(i * 50)
                                .toArray()];
                    case 2:
                        batch = _d.sent();
                        if (batch.length === 0) {
                            return [3 /*break*/, 4];
                        }
                        for (_i = 0, batch_1 = batch; _i < batch_1.length; _i++) {
                            set = batch_1[_i];
                            if (typeof set.when === 'number') {
                                set.when = moment(set.when)
                                    .hour(0)
                                    .minute(0)
                                    .second(0)
                                    .millisecond(0);
                            }
                            if (!days[+set.when]) {
                                days[+set.when] = {};
                            }
                            if (!days[+set.when][set.name]) {
                                days[+set.when][set.name] = [set, 1];
                            }
                            else {
                                days[+set.when][set.name][1]++;
                            }
                        }
                        _d.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        ret = [];
                        dates = Object.getOwnPropertyNames(days);
                        dates.sort();
                        for (_a = 0, dates_1 = dates; _a < dates_1.length; _a++) {
                            dayKey = dates_1[_a];
                            day = days[dayKey];
                            for (_b = 0, _c = Object.getOwnPropertyNames(day); _b < _c.length; _b++) {
                                weightKey = _c[_b];
                                ret.push(day[weightKey]);
                            }
                        }
                        return [2 /*return*/, ret];
                }
            });
        });
    };
    Data.prototype.getWeightSet = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var ret;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.weightSets.get(id)];
                    case 1:
                        ret = _a.sent();
                        if (typeof ret.when === 'number') {
                            ret.when = moment(ret.when);
                        }
                        return [2 /*return*/, ret];
                }
            });
        });
    };
    Data.prototype.addWeightSet = function (set) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        set.when = +set.when;
                        _a = set;
                        return [4 /*yield*/, this.weightSets.add(set)];
                    case 1:
                        _a.id = _b.sent();
                        this.renderableChanges.emit();
                        this.syncableChanges.emit();
                        return [2 /*return*/, set];
                }
            });
        });
    };
    Data.prototype.addWeightSets = function (sets) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sets = sets.map(function (s) {
                            s.when = +s.when;
                            return s;
                        });
                        return [4 /*yield*/, this.weightSets
                                .bulkAdd(sets)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Data.prototype.updateWeightSet = function (set) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof set.when !== 'number') {
                            set.when = +set.when;
                        }
                        return [4 /*yield*/, this.weightSets.put(set, set.id)];
                    case 1:
                        _a.sent();
                        this.renderableChanges.emit();
                        this.syncableChanges.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    Data.prototype.deleteWeightSet = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.weightSets.delete(id)];
                    case 1:
                        _a.sent();
                        this.renderableChanges.emit();
                        this.syncableChanges.emit();
                        return [2 /*return*/];
                }
            });
        });
    };
    Data.prototype.getLastWeight = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.users
                            .orderBy('updated')
                            .reverse()
                            .limit(50)
                            .and(function (b) { return !b.deleted; })
                            .first()];
                    case 1: return [2 /*return*/, (_a.sent())
                            .weight];
                }
            });
        });
    };
    Data.prototype.searchDistinctExerciseNames = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var records, names;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.weightSets
                            .where('name')
                            .startsWithIgnoreCase(name)
                            .toArray()];
                    case 1:
                        records = _a.sent();
                        names = records.reduce(this.searchReducer, new Set());
                        return [2 /*return*/, Array.from(names)];
                }
            });
        });
    };
    Data.prototype.searchReducer = function (acc, ws) {
        acc.add(ws.name);
        return acc;
    };
    Data.prototype.mostRecentFor = function (name) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.weightSets
                            .orderBy('when')
                            .filter(function (ws) { return ws.name === name; })
                            .reverse()
                            .first()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    Data.ngInjectableDef = i0.defineInjectable({ factory: function Data_Factory() { return new Data(); }, token: Data, providedIn: "root" });
    return Data;
}(Database));
export { Data };
var NameTimePair = /** @class */ (function () {
    function NameTimePair(name, time) {
        this.name = name;
        this.time = time;
    }
    NameTimePair.prototype.valueOf = function () {
        return this.name + "-" + this.time;
    };
    return NameTimePair;
}());
